export default "__VITE_ASSET__Bfr3sysu__"